import PropTypes from 'prop-types';
import { Routes, Route, Navigate } from 'react-router-dom';
import NotFoundPage from 'pages/NotFoundPage';
import PrivateRoute from './PrivateRoute';
import LoginRoute from './LoginRoute';
import routes from './routes';

const Router = ({ mixpanel }) => (
  <Routes>
    <Route exact path="/" element={<Navigate to="/register" />} />
    {routes.public(mixpanel).map(route => (
      <Route exact key={route.path} path={route.path} element={route.component} />
    ))}
    {routes.private(mixpanel).map(route => (
      <Route exact key={route.path} path={route.path} element={<PrivateRoute />}>
        <Route exact path={route.path} element={route.component} />
      </Route>
    ))}
    <Route exact path="/login" element={<LoginRoute isLogin />} />
    <Route exact path="/signUp" element={<LoginRoute />} />
    <Route exact path="*" element={<NotFoundPage />} />
  </Routes>
);

Router.propTypes = {
  mixpanel: PropTypes.shape({}),
};

Router.defaultProps = {
  mixpanel: {},
};

export default Router;
